import axios from 'axios';

import { Tracker } from 'services/tracking';
import sessionService from 'services/session';
import { getHostedPageFlowType } from 'utilities/global';
import { GA_CATEGORIES, GA_ACTIONS } from 'consts';
import store from 'redux/store';

class ApiService {
  API;

  initApi = ({ base_url: baseUrl }) => {
    const tracker = new Tracker(getHostedPageFlowType());
    const base = window.Cypress ? window.Cypress.env('proxyUrl') : baseUrl;

    this.API = axios.create({
      baseURL: base,
      headers: {
        'Content-Type': 'application/json',
        is_standby: window.location.origin.includes('preview') ? 1 : 0
      }
    });

    // Send API errors to GA.
    this.API.interceptors.response.use(
      response => {
        return response;
      },
      error => {
        if (error.response?.status === 404 || error.response?.status === 500) {
          const label = `Error code ${error.response.status}`;
          tracker.fireEvent({
            category: GA_CATEGORIES.ERRORS,
            action: GA_ACTIONS.API_ERROR,
            label
          });
        } else {
          const label = JSON.stringify({
            code: error.response?.data.status.error_code,
            message: error.response?.data.status.message
          });
          tracker.fireEvent({
            category: GA_CATEGORIES.ERRORS,
            action: GA_ACTIONS.API_ERROR,
            label
          });
        }

        throw error;
      }
    );
  };

  getHeaders = ({ headers = {}, pageToken }) => {
    let session;
    if (pageToken) {
      session = sessionService.getSession(pageToken);
    }
    return {
      ...headers,
      ...(session && { session_id: session })
    };
  };

  getData = data => {
    return {
      ...data,
      ...(store.getState().global.isSdk ? { is_sdk: '1' } : {})
    };
  };

  makeApiCall = ({ method, url, data = {}, headers = {}, pageToken }) => {
    const requestHeaders = this.getHeaders({ headers, pageToken });
    return this[method](url, this.getData(data), requestHeaders);
  };

  get = (url, data, headers = {}) =>
    this.API.get(url, {
      params: this.getData(data),
      headers: this.getHeaders({ headers })
    });

  post = (url, data, headers = {}) =>
    this.API.post(url, this.getData(data), { headers: this.getHeaders({ headers }) });

  put = (url, data, headers = {}) =>
    this.API.put(url, this.getData(data), { headers: this.getHeaders({ headers }) });

  delete = (url, data, headers = {}) =>
    this.API.delete(url, {
      data: this.getData(data),
      headers: this.getHeaders({ headers })
    });
}

const api = new ApiService();
export const { initApi } = api;
export default api;
